import { COVERGO_SAAS_DEV, COVERGO_ASIA_GCP_QA, COVERGO_GCP_ASIA_UAT, COVERGO_GCP_ASIA_PROD } from "../consts.js"

export const prudential_dev = {
	"pru-studio.dev.asia.covergo.dev": {
		appConfig: {
			tenantId: "prudential_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV,
		fileSystem: {
			bucketName: "covergo-apse1-dev-prudential-dev"
		}
	}
}

export const prudential_qa = {
	"pru-studio.qa.pru.asia.covergo.net": {
		appConfig: {
			tenantId: "prudential_qa",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_ASIA_GCP_QA,
		fileSystem: {
			bucketName: "pru-qa"
		}
	}
}

export const prudential_uat = {
	"pru-studio.uat.pru.asia.covergo.dev": {
		appConfig: {
			tenantId: "prudential_uat",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_GCP_ASIA_UAT,
		fileSystem: {
			bucketName: "pru-uat"
		}
	}
}

export const prudential_prod = {
	"pru-studio.prod.pru.asia.covergo.net": {
		appConfig: {
			tenantId: "prudential_prod",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_GCP_ASIA_PROD,
		fileSystem: {
			bucketName: "pru-prod"
		}
	}
}